<template>
  <c-modal centered :tag="false" size="lg" v-model="modal" :title="item.Name">
    <template>
      <b-container class="px-0" fluid>
        <b-row>
          <b-col cols="12">
            <div class="w-100">
              <img class="mb-0" :src="getPhoto" width="100%"/>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </template>
    <template #actions>
      <b-row class="flex-grow-1">
        <b-col cols="12">
          <b-btn variant="danger" @click="modal = false" block>Close</b-btn>
        </b-col>
      </b-row>
    </template>
  </c-modal>
</template>

<script>
  import CModal from "../../../../shared/Cmodal";
  import config from "SrcConfig";

  export default {
    name: "itemImage",
    components: {CModal},
    props: {
      value: {
        required: true,
        type: Boolean,
        default: false
      },
      item: {
        required: true,
        type: Object,
        default: {}
      }
    },
    computed: {
      modal: {
        get () {
          return this.value
        },
        set(val) {
          this.$emit('input', val)
        }
      },
      getPhoto () {
        let baseUrl = config.files.baseurlimage;
        if (config.files.baseurlimage.search('www') != -1) {
          baseUrl = "https://images.menupoly.com";
        }
        return config.files.baseurlimage + `/UserUpload/User_${localStorage.getItem('restaurantProfile')}/` + this.item.Photo1
      }
    }
  }
</script>

<style scoped>

</style>
